const {h, render, Component} = require('preact');
const TabsView = require('../../views/common/tabs')
const MY_GROUPONS = 'my-groupons'
const MY_GPLUS_DEALS = 'my-gplus-deals'
const ACTIVE = ' active'

class Tabs extends Component {
  constructor(props) {
    super(props);
    this.switchTabs = this.switchTabs.bind(this);
    this.state = {};
    this.state.grouponsTab = MY_GROUPONS
    this.state.gplusTab = MY_GPLUS_DEALS
    if (this.props.page === MY_GROUPONS) {
      this.state.grouponsTab += ACTIVE
    } else {
      this.state.gplusTab += ACTIVE
    }
  }

  switchTabs(tab) {
    if (tab === MY_GROUPONS) {
      this.setState({
        grouponsTab: ACTIVE + {tab},
        gplusTab: MY_GPLUS_DEALS
      });
    } else {
      this.setState({
        grouponsTab: MY_GROUPONS,
        gplusTab: ACTIVE + {tab}
      });
    }
  };

  render() {
    return (
        <TabsView
            state={this.state}
            switchTabs={event => {
              event.preventDefault();
              this.switchTabs()
            }}
        />
    )
  }
}

module.exports = Tabs
